import React, { useMemo } from 'react';
import { Form, SplitFormRow } from '../../../../../v2BaseComponents/Form';
import { ClientInvitation } from '../../../../../../hooks/api/useMyOrganizationClientInvitations';
import { NewProfileInfo } from '../../../types';
import { FormStack } from '../../../../../v2BaseComponents/Stack';
import { getIntl } from '../../../../../../utils/intl';
import { Field } from 'formik';
import { FormikInputs } from '../../../../../v2BaseComponents/Inputs';
import { composeValidators, getDateFormatValidator, required } from '../../../../../../utils/validators';
import StepCompleteButton from '../../StepCompleteButton';

const intl = getIntl('organization-client-invitation-create-profile', {
    createProfile: 'Create Profile',
    firstName: 'First Name',
    lastName: 'Last Name',
    dateOfBirth: 'Date of Birth',
    preferredName: 'Preferred Name',
    submit: 'Submit',
});

export type CreateProfileOwnProps = {
    clientInvitation: ClientInvitation;
    onSubmit: (values: NewProfileInfo) => void;
};

export type CreateProfileProps = CreateProfileOwnProps;

const CreateProfile: React.FC<CreateProfileProps> = (props) => {
    const initialValues = useMemo<NewProfileInfo>(
        () => ({
            firstName: props.clientInvitation.clientFirstName,
            lastName: props.clientInvitation.clientLastName,
            dateOfBirth: props.clientInvitation.clientDOB,
            preferredName: '',
        }),
        [props.clientInvitation],
    );
    return (
        <Form initialValues={initialValues} onSubmit={(values) => props.onSubmit(values)}>
            {({ handleSubmit }) => (
                <FormStack>
                    <SplitFormRow>
                        <Field
                            name="firstName"
                            component={FormikInputs.Input}
                            title={intl('firstName')}
                            validate={required}
                            isRequired
                        />
                        <Field name="preferredName" component={FormikInputs.Input} title={intl('preferredName')} />
                    </SplitFormRow>
                    <SplitFormRow>
                        <Field
                            name="lastName"
                            component={FormikInputs.Input}
                            title={intl('lastName')}
                            validate={required}
                            isRequired
                        />
                        <Field
                            name="dateOfBirth"
                            component={FormikInputs.DateTimePicker}
                            title={intl('dateOfBirth')}
                            validate={composeValidators(required, getDateFormatValidator('MM/DD/YYYY'))}
                        />
                    </SplitFormRow>
                    <StepCompleteButton
                        onPress={handleSubmit}
                        isDisabled={false}
                        variant="next"
                        testID="organization-invitation-create-profile-complete"
                    />
                </FormStack>
            )}
        </Form>
    );
};

export default React.memo(CreateProfile);
